import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { JwtService } from '@app/core/services/jwt.service';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';
import { CustomValidators } from '@app/modules/users/validators/custom-validators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})

export class ChangePasswordComponent implements OnInit {
  public processComplete: boolean = false;
  public hide: boolean = true;
  public form: FormGroup;
  public errors = null;
  public token: string;
  public isEmbedMode: boolean = false;
  public isLoading: boolean = true;
  public tokenError: string | null = null;
  public tokenErrorCode: string | null = null;

  constructor(
    public fb: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public authService: JwtService,
    private route: ActivatedRoute,
    private _router: Router,
    private _translation: TranslateService,
  ) {
    this.form = this.fb.group({
      usrPassword: new FormControl('', Validators.compose([
        Validators.required,
        // check whether the entered password has a number
        CustomValidators.patternValidator(/\d/, {
          hasNumber: true
        }),
        // check whether the entered password has upper case letter
        CustomValidators.patternValidator(/[A-Z]/, {
          hasCapitalCase: true
        }),
        // check whether the entered password has a lower case letter
        CustomValidators.patternValidator(/[a-z]/, {
          hasSmallCase: true
        }),
        // check whether the entered password has a special character
        CustomValidators.patternValidator(
          /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
          {
            hasSpecialCharacters: true
          }
        ),
        Validators.minLength(8)
      ])),
      usrPassword_confirmation: new FormControl('', Validators.compose([
        Validators.required,
        // check whether the entered password has a number
        CustomValidators.patternValidator(/\d/, {
          hasNumber: true
        }),
        // check whether the entered password has upper case letter
        CustomValidators.patternValidator(/[A-Z]/, {
          hasCapitalCase: true
        }),
        // check whether the entered password has a lower case letter
        CustomValidators.patternValidator(/[a-z]/, {
          hasSmallCase: true
        }),
        // check whether the entered password has a special character
        CustomValidators.patternValidator(
          /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
          {
            hasSpecialCharacters: true
          }
        ),
        Validators.minLength(8)
      ])),
      token: new FormControl('')
    })
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      // Check both URL param and iframe detection
      this.isEmbedMode = params['embed'] === 'true' || window !== window.top;

      if (this.token) {
        this.validateToken();
      } else {
        this.isLoading = false;
        this.tokenError = 'No token provided.';
        this.tokenErrorCode = 'NO_TOKEN';
      }
    });
  }

  private validateToken(): void {
    this.authService.validateResetToken(this.token).subscribe({
      next: () => {
        this.isLoading = false;
        this.tokenError = null;
      },
      error: (error) => {
        this.isLoading = false;
        this.tokenError = error.error?.message || 'Invalid token.';
        this.tokenErrorCode = error.error?.error || 'INVALID_TOKEN';
      }
    });
  }

  onSubmit() {
    this.form.patchValue({
      token: this.token
    });
    this.authService.resetPassword(this.form.value).subscribe({
      next: (res)=> {
        this.form.reset();
        /*if(res['deviceType']== 'web'){
          return this._router.navigate(['/']);
        }
        return this._router.navigate(['/']);*/
        this.processComplete = true;
      },
      error: error => {
        this.handleError(error);
      },
    });
  }

  goToLogin() {
    if (this.isEmbedMode && window.parent !== window) {
      window.parent.postMessage({
        type: 'TRAKR_PASSWORD_SET',
        redirectUrl: '/login'
      }, '*');
    } else {
      this._router.navigate(['/login']);
    }
  }

  goToHome() {
    if (this.isEmbedMode && window.parent !== window) {
      window.parent.postMessage({
        type: 'TRAKR_GO_HOME',
        redirectUrl: '/'
      }, '*');
    } else {
      window.location.href = 'https://www.trakrsuite.com';
    }
  }

  requestNewLink(): void {
    if (this.isEmbedMode && window.parent !== window) {
      // Use TRAKR_GO_HOME which parent already handles
      window.parent.postMessage({
        type: 'TRAKR_GO_HOME',
        redirectUrl: '/reset-password'
      }, '*');
    } else {
      this._router.navigate(['/reset-password']);
    }
  }

  handleError(error) {
    this.processComplete = false;
    let errorMsg = '';
    if (error.error instanceof ErrorEvent) {
      errorMsg = `${this._translation.instant('error')}: ${error.error.message}`;
    } else {
      errorMsg = `${this._translation.instant('error_code')}: ${error.status}\n${this._translation.instant('message')}: ${error.message}`;
    }
    return throwError(errorMsg);
  }

}
